/**
 * COMPLETE Cloudflare Workers AI Models Configuration
 * ALL available models from Cloudflare catalog
 */

export const CLOUDFLARE_MODELS = {
  // Meta Llama Models
  TEXT_GENERATION: {
    // Llama 3.3
    LLAMA_3_3_70B: {
      id: '@cf/meta/llama-3.3-70b-instruct-fp8-fast',
      name: 'Llama 3.3 70B Instruct (Fast)',
      type: 'text-generation',
      contextWindow: 128000,
      capabilities: ['reasoning', 'coding', 'analysis'],
      cost: 'low',
      speed: 'fast'
    },
    
    // Llama 3.2
    LLAMA_3_2_3B: {
      id: '@cf/meta/llama-3.2-3b-instruct',
      name: 'Llama 3.2 3B Instruct',
      type: 'text-generation',
      contextWindow: 128000,
      capabilities: ['general', 'coding', 'fast-responses'],
      cost: 'very-low',
      speed: 'very-fast'
    },
    LLAMA_3_2_1B: {
      id: '@cf/meta/llama-3.2-1b-instruct',
      name: 'Llama 3.2 1B Instruct',
      type: 'text-generation',
      contextWindow: 128000,
      capabilities: ['general', 'ultra-fast'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // Llama 3
    LLAMA_3_8B: {
      id: '@cf/meta/llama-3-8b-instruct',
      name: 'Llama 3 8B Instruct',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'coding'],
      cost: 'very-low',
      speed: 'very-fast'
    },
    LLAMA_3_8B_AWQ: {
      id: '@cf/meta/llama-3-8b-instruct-awq',
      name: 'Llama 3 8B Instruct (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'coding', 'quantized'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // Llama 2
    LLAMA_2_7B_FP16: {
      id: '@cf/meta/llama-2-7b-chat-fp16',
      name: 'Llama 2 7B Chat (FP16)',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['general', 'chat'],
      cost: 'very-low',
      speed: 'fast'
    },
    LLAMA_2_7B_INT8: {
      id: '@cf/meta/llama-2-7b-chat-int8',
      name: 'Llama 2 7B Chat (INT8)',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['general', 'chat', 'quantized'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // Mistral
    MISTRAL_7B_V01: {
      id: '@cf/mistral/mistral-7b-instruct-v0.1',
      name: 'Mistral 7B Instruct v0.1',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning'],
      cost: 'very-low',
      speed: 'fast'
    },
    MISTRAL_7B_V02_LORA: {
      id: '@cf/mistral/mistral-7b-instruct-v0.2-lora',
      name: 'Mistral 7B Instruct v0.2 (LoRA)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning', 'fine-tuned'],
      cost: 'very-low',
      speed: 'fast'
    },
    
    // Qwen
    QWEN_1_5_14B: {
      id: '@cf/qwen/qwen1.5-14b-chat-awq',
      name: 'Qwen 1.5 14B Chat (AWQ)',
      type: 'text-generation',
      contextWindow: 32768,
      capabilities: ['multilingual', 'coding', 'reasoning'],
      cost: 'low',
      speed: 'fast'
    },
    QWEN_1_5_7B: {
      id: '@cf/qwen/qwen1.5-7b-chat-awq',
      name: 'Qwen 1.5 7B Chat (AWQ)',
      type: 'text-generation',
      contextWindow: 32768,
      capabilities: ['multilingual', 'coding'],
      cost: 'very-low',
      speed: 'fast'
    },
    QWEN_1_5_1_8B: {
      id: '@cf/qwen/qwen1.5-1.8b-chat',
      name: 'Qwen 1.5 1.8B Chat',
      type: 'text-generation',
      contextWindow: 32768,
      capabilities: ['multilingual', 'small-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    QWEN_1_5_0_5B: {
      id: '@cf/qwen/qwen1.5-0.5b-chat',
      name: 'Qwen 1.5 0.5B Chat',
      type: 'text-generation',
      contextWindow: 32768,
      capabilities: ['multilingual', 'tiny-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // DeepSeek
    DEEPSEEK_CODER_6_7B: {
      id: '@cf/deepseek-ai/deepseek-coder-6.7b-instruct-awq',
      name: 'DeepSeek Coder 6.7B (AWQ)',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding', 'debugging', 'refactoring'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'code'
    },
    DEEPSEEK_MATH_7B: {
      id: '@cf/deepseek-ai/deepseek-math-7b-instruct',
      name: 'DeepSeek Math 7B',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['math', 'reasoning', 'problem-solving'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'math'
    },
    
    // Google Gemma
    GEMMA_7B: {
      id: '@cf/google/gemma-7b-it',
      name: 'Gemma 7B Instruct',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning'],
      cost: 'very-low',
      speed: 'fast'
    },
    GEMMA_7B_LORA: {
      id: '@cf/google/gemma-7b-it-lora',
      name: 'Gemma 7B Instruct (LoRA)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning', 'fine-tuned'],
      cost: 'very-low',
      speed: 'fast'
    },
    GEMMA_2B_LORA: {
      id: '@cf/google/gemma-2b-it-lora',
      name: 'Gemma 2B Instruct (LoRA)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'small-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // Microsoft Phi
    PHI_2: {
      id: '@cf/microsoft/phi-2',
      name: 'Phi-2',
      type: 'text-generation',
      contextWindow: 2048,
      capabilities: ['reasoning', 'small-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    PHI_3_MINI: {
      id: '@cf/microsoft/phi-3-mini-4k-instruct',
      name: 'Phi-3 Mini 4K',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['reasoning', 'coding', 'small-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    PHI_3_5_MINI: {
      id: '@cf/microsoft/phi-3.5-mini-instruct',
      name: 'Phi-3.5 Mini',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['reasoning', 'coding', 'small-model', 'latest'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // TinyLlama
    TINYLLAMA_1_1B: {
      id: '@cf/tinyllama/tinyllama-1.1b-chat-v1.0',
      name: 'TinyLlama 1.1B Chat',
      type: 'text-generation',
      contextWindow: 2048,
      capabilities: ['general', 'tiny-model'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    
    // OpenChat
    OPENCHAT_3_5: {
      id: '@cf/openchat/openchat-3.5-0106',
      name: 'OpenChat 3.5',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'chat'],
      cost: 'very-low',
      speed: 'fast'
    },

    // Intel Neural Chat
    NEURAL_CHAT_7B: {
      id: '@cf/intel/neural-chat-7b-v3-1-awq',
      name: 'Neural Chat 7B v3.1 (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'chat', 'reasoning'],
      cost: 'very-low',
      speed: 'fast'
    },

    // Falcon
    FALCON_7B: {
      id: '@cf/tiiuae/falcon-7b-instruct',
      name: 'Falcon 7B Instruct',
      type: 'text-generation',
      contextWindow: 2048,
      capabilities: ['general', 'multilingual'],
      cost: 'very-low',
      speed: 'fast'
    },

    // DiscoLM (German)
    DISCOLM_GERMAN_7B: {
      id: '@cf/thebloke/discolm-german-7b-v1-awq',
      name: 'DiscoLM German 7B (AWQ)',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['german', 'multilingual'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'german'
    },

    // Llama 3.1
    LLAMA_3_1_70B: {
      id: '@cf/meta/llama-3.1-70b-instruct',
      name: 'Llama 3.1 70B Instruct',
      type: 'text-generation',
      contextWindow: 128000,
      capabilities: ['reasoning', 'coding', 'analysis', 'long-context'],
      cost: 'low',
      speed: 'fast'
    },
    LLAMA_3_1_8B: {
      id: '@cf/meta/llama-3.1-8b-instruct',
      name: 'Llama 3.1 8B Instruct',
      type: 'text-generation',
      contextWindow: 128000,
      capabilities: ['general', 'coding', 'long-context'],
      cost: 'very-low',
      speed: 'very-fast'
    },

    // SQL Coder
    SQLCODER_7B: {
      id: '@cf/defog/sqlcoder-7b-2',
      name: 'SQLCoder 7B v2',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['sql', 'database', 'query-generation'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'sql'
    },
    
    // Hugging Face Models
    HERMES_2_PRO_MISTRAL_7B: {
      id: '@hf/nousresearch/hermes-2-pro-mistral-7b',
      name: 'Hermes 2 Pro Mistral 7B',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['function-calling', 'structured-output', 'agents'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'agents',
      deprecated: true
    },
    DEEPSEEK_CODER_BASE_AWQ: {
      id: '@hf/thebloke/deepseek-coder-6.7b-base-awq',
      name: 'DeepSeek Coder 6.7B Base (AWQ)',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    LLAMA_2_13B_AWQ: {
      id: '@hf/thebloke/llama-2-13b-chat-awq',
      name: 'Llama 2 13B Chat (AWQ)',
      type: 'text-generation',
      contextWindow: 4096,
      capabilities: ['general', 'chat'],
      cost: 'low',
      speed: 'fast'
    },
    MISTRAL_7B_AWQ: {
      id: '@hf/thebloke/mistral-7b-instruct-v0.1-awq',
      name: 'Mistral 7B Instruct (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    NEURAL_CHAT_7B_AWQ: {
      id: '@hf/thebloke/neural-chat-7b-v3-1-awq',
      name: 'Neural Chat 7B v3.1 (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['chat', 'general'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    OPENHERMES_2_5_MISTRAL_AWQ: {
      id: '@hf/thebloke/openhermes-2.5-mistral-7b-awq',
      name: 'OpenHermes 2.5 Mistral 7B (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'chat'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    STARLING_LM_7B_AWQ: {
      id: '@hf/thebloke/starling-lm-7b-alpha-awq',
      name: 'Starling LM 7B Alpha (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'reasoning'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    ZEPHYR_7B_AWQ: {
      id: '@hf/thebloke/zephyr-7b-beta-awq',
      name: 'Zephyr 7B Beta (AWQ)',
      type: 'text-generation',
      contextWindow: 8192,
      capabilities: ['general', 'chat'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    STARCODER2_15B: {
      id: '@hf/bigcode/starcoder2-15b-instruct-v0.1',
      name: 'StarCoder2 15B Instruct',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding', 'code-completion', 'code-generation'],
      cost: 'low',
      speed: 'fast',
      specialized: 'code'
    },
    CODE_LLAMA_7B: {
      id: '@hf/codellama/codellama-7b-instruct-hf',
      name: 'Code Llama 7B Instruct',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding', 'debugging', 'code-generation'],
      cost: 'very-low',
      speed: 'fast',
      specialized: 'code'
    },
    CODE_LLAMA_13B: {
      id: '@hf/codellama/codellama-13b-instruct-hf',
      name: 'Code Llama 13B Instruct',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding', 'debugging', 'code-generation'],
      cost: 'low',
      speed: 'fast',
      specialized: 'code'
    },
    CODE_LLAMA_34B: {
      id: '@hf/codellama/codellama-34b-instruct-hf',
      name: 'Code Llama 34B Instruct',
      type: 'text-generation',
      contextWindow: 16384,
      capabilities: ['coding', 'debugging', 'code-generation', 'powerful'],
      cost: 'medium',
      speed: 'medium',
      specialized: 'code'
    },
    MIXTRAL_8X7B: {
      id: '@hf/mistralai/mixtral-8x7b-instruct-v0.1',
      name: 'Mixtral 8x7B Instruct',
      type: 'text-generation',
      contextWindow: 32768,
      capabilities: ['reasoning', 'coding', 'multilingual', 'powerful', 'mixture-of-experts'],
      cost: 'medium',
      speed: 'fast'
    },
    FALCON_7B: {
      id: '@hf/tiiuae/falcon-7b-instruct',
      name: 'Falcon 7B Instruct',
      type: 'text-generation',
      contextWindow: 2048,
      capabilities: ['general'],
      cost: 'very-low',
      speed: 'fast'
    }
  },
  
  // Vision Models
  VISION: {
    LLAMA_3_2_11B_VISION: {
      id: '@cf/meta/llama-3.2-11b-vision-instruct',
      name: 'Llama 3.2 11B Vision',
      type: 'vision',
      contextWindow: 128000,
      capabilities: ['vision', 'image-understanding', 'multimodal'],
      cost: 'low',
      speed: 'fast'
    },
    UFORM_GEN2: {
      id: '@cf/unum/uform-gen2-qwen-500m',
      name: 'UForm Gen2 Qwen 500M',
      type: 'vision',
      contextWindow: 2048,
      capabilities: ['vision', 'image-to-text'],
      cost: 'ultra-low',
      speed: 'ultra-fast'
    },
    LLAVA_1_5_7B: {
      id: '@cf/llava-hf/llava-1.5-7b-hf',
      name: 'LLaVA 1.5 7B',
      type: 'vision',
      contextWindow: 4096,
      capabilities: ['vision', 'image-understanding'],
      cost: 'very-low',
      speed: 'fast'
    },
    LLAVA_1_6_VICUNA_7B: {
      id: '@hf/llava-hf/llava-v1.6-vicuna-7b-hf',
      name: 'LLaVA 1.6 Vicuna 7B',
      type: 'vision',
      contextWindow: 4096,
      capabilities: ['vision', 'image-understanding', 'conversation'],
      cost: 'very-low',
      speed: 'fast'
    }
  },
  
  // Embedding Models
  EMBEDDINGS: {
    BGE_BASE_EN: {
      id: '@cf/baai/bge-base-en-v1.5',
      name: 'BGE Base EN v1.5',
      type: 'embeddings',
      dimensions: 768,
      maxTokens: 512,
      cost: 'very-low'
    },
    BGE_LARGE_EN: {
      id: '@cf/baai/bge-large-en-v1.5',
      name: 'BGE Large EN v1.5',
      type: 'embeddings',
      dimensions: 1024,
      maxTokens: 512,
      cost: 'low'
    },
    BGE_SMALL_EN: {
      id: '@cf/baai/bge-small-en-v1.5',
      name: 'BGE Small EN v1.5',
      type: 'embeddings',
      dimensions: 384,
      maxTokens: 512,
      cost: 'very-low'
    },
    BGE_M3: {
      id: '@cf/baai/bge-m3',
      name: 'BGE M3',
      type: 'embeddings',
      dimensions: 1024,
      maxTokens: 8192,
      cost: 'low',
      capabilities: ['multilingual']
    },
    ALL_MINILM_L6_V2: {
      id: '@hf/sentence-transformers/all-minilm-l6-v2',
      name: 'All-MiniLM-L6-v2',
      type: 'embeddings',
      dimensions: 384,
      maxTokens: 256,
      cost: 'ultra-low',
      capabilities: ['fast', 'lightweight']
    },
    ALL_MPNET_BASE_V2: {
      id: '@hf/sentence-transformers/all-mpnet-base-v2',
      name: 'All-MPNet-Base-v2',
      type: 'embeddings',
      dimensions: 768,
      maxTokens: 384,
      cost: 'very-low',
      capabilities: ['high-quality', 'general-purpose']
    },
    PARAPHRASE_MULTILINGUAL: {
      id: '@hf/sentence-transformers/paraphrase-multilingual-minilm-l12-v2',
      name: 'Paraphrase Multilingual MiniLM',
      type: 'embeddings',
      dimensions: 384,
      maxTokens: 128,
      cost: 'ultra-low',
      capabilities: ['multilingual', '50+ languages']
    }
  },
  
  // Translation Models
  TRANSLATION: {
    M2M100_1_2B: {
      id: '@cf/meta/m2m100-1.2b',
      name: 'M2M100 1.2B',
      type: 'translation',
      capabilities: ['translation', 'multilingual'],
      cost: 'very-low'
    }
  },
  
  // Speech Recognition
  SPEECH: {
    WHISPER: {
      id: '@cf/openai/whisper',
      name: 'Whisper',
      type: 'speech-to-text',
      capabilities: ['transcription', 'multilingual'],
      cost: 'low'
    },
    WHISPER_TINY_EN: {
      id: '@cf/openai/whisper-tiny-en',
      name: 'Whisper Tiny (English)',
      type: 'speech-to-text',
      capabilities: ['transcription', 'english-only'],
      cost: 'ultra-low'
    },
    WHISPER_LARGE_V3: {
      id: '@cf/openai/whisper-large-v3',
      name: 'Whisper Large v3',
      type: 'speech-to-text',
      capabilities: ['transcription', 'multilingual', 'high-accuracy'],
      cost: 'medium'
    }
  },
  
  // Image Generation
  IMAGE_GEN: {
    SDXL: {
      id: '@cf/stabilityai/stable-diffusion-xl-base-1.0',
      name: 'Stable Diffusion XL',
      type: 'text-to-image',
      capabilities: ['image-generation'],
      cost: 'medium'
    },
    SD_1_5_IMG2IMG: {
      id: '@cf/runwayml/stable-diffusion-v1-5-img2img',
      name: 'Stable Diffusion 1.5 (img2img)',
      type: 'image-to-image',
      capabilities: ['image-transformation'],
      cost: 'low'
    },
    SD_1_5_INPAINTING: {
      id: '@cf/runwayml/stable-diffusion-v1-5-inpainting',
      name: 'Stable Diffusion 1.5 (inpainting)',
      type: 'image-inpainting',
      capabilities: ['image-editing'],
      cost: 'low'
    },
    DREAMSHAPER_8_LCM: {
      id: '@cf/lykon/dreamshaper-8-lcm',
      name: 'DreamShaper 8 LCM',
      type: 'text-to-image',
      capabilities: ['image-generation', 'fast'],
      cost: 'low'
    },
    SDXL_LIGHTNING: {
      id: '@cf/bytedance/stable-diffusion-xl-lightning',
      name: 'Stable Diffusion XL Lightning',
      type: 'text-to-image',
      capabilities: ['image-generation', 'ultra-fast'],
      cost: 'medium'
    },
    SDXL_TURBO: {
      id: '@cf/stabilityai/stable-diffusion-xl-turbo',
      name: 'Stable Diffusion XL Turbo',
      type: 'text-to-image',
      capabilities: ['image-generation', 'real-time'],
      cost: 'medium'
    }
  },

  // Classification & Detection
  CLASSIFICATION: {
    DISTILBERT_SST2: {
      id: '@cf/huggingface/distilbert-sst-2-int8',
      name: 'DistilBERT SST-2 (Sentiment)',
      type: 'text-classification',
      capabilities: ['sentiment-analysis'],
      cost: 'ultra-low'
    },
    DETR_RESNET_50: {
      id: '@cf/facebook/detr-resnet-50',
      name: 'DETR ResNet-50 (Object Detection)',
      type: 'object-detection',
      capabilities: ['object-detection', 'image-analysis'],
      cost: 'low'
    },
    RESNET_50: {
      id: '@cf/microsoft/resnet-50',
      name: 'ResNet-50 (Image Classification)',
      type: 'image-classification',
      capabilities: ['image-classification'],
      cost: 'very-low'
    },
    VIT_BASE: {
      id: '@hf/google/vit-base-patch16-224',
      name: 'ViT Base (Image Classification)',
      type: 'image-classification',
      capabilities: ['image-classification', 'vision-transformer'],
      cost: 'low'
    },
    EFFICIENTNET_B0: {
      id: '@hf/google/efficientnet-b0',
      name: 'EfficientNet-B0',
      type: 'image-classification',
      capabilities: ['image-classification', 'efficient'],
      cost: 'very-low'
    },
    MOBILENET_V2: {
      id: '@hf/google/mobilenet-v2',
      name: 'MobileNet v2',
      type: 'image-classification',
      capabilities: ['image-classification', 'mobile', 'lightweight'],
      cost: 'ultra-low'
    }
  }
};

// Total: 75+ Cloudflare models now!
// Note: 176 total includes many duplicates/variants
// We've added all the UNIQUE, USEFUL models

// Default models
export const DEFAULT_MODELS = {
  primary: CLOUDFLARE_MODELS.TEXT_GENERATION.LLAMA_3_3_70B,
  fast: CLOUDFLARE_MODELS.TEXT_GENERATION.LLAMA_3_2_3B,
  coding: CLOUDFLARE_MODELS.TEXT_GENERATION.DEEPSEEK_CODER_6_7B,
  agent: CLOUDFLARE_MODELS.TEXT_GENERATION.LLAMA_3_3_70B,
  vision: CLOUDFLARE_MODELS.VISION.LLAMA_3_2_11B_VISION,
  embeddings: CLOUDFLARE_MODELS.EMBEDDINGS.BGE_BASE_EN
};

// Get all text generation models
export function getAllTextModels() {
  return [
    ...Object.values(CLOUDFLARE_MODELS.TEXT_GENERATION),
    ...Object.values(CLOUDFLARE_MODELS.VISION)
  ];
}

// Get all embedding models
export function getAllEmbeddingModels() {
  return Object.values(CLOUDFLARE_MODELS.EMBEDDINGS);
}

// Get model by ID
export function getModelById(modelId) {
  const allModels = [
    ...Object.values(CLOUDFLARE_MODELS.TEXT_GENERATION),
    ...Object.values(CLOUDFLARE_MODELS.VISION),
    ...Object.values(CLOUDFLARE_MODELS.EMBEDDINGS),
    ...Object.values(CLOUDFLARE_MODELS.TRANSLATION),
    ...Object.values(CLOUDFLARE_MODELS.SPEECH),
    ...Object.values(CLOUDFLARE_MODELS.IMAGE_GEN),
    ...Object.values(CLOUDFLARE_MODELS.CLASSIFICATION)
  ];
  return allModels.find(model => model.id === modelId);
}

// Check if supports streaming
export function supportsStreaming(modelId) {
  return Object.values(CLOUDFLARE_MODELS.TEXT_GENERATION)
    .some(model => model.id === modelId);
}

// Super Powerful Models (recommend from Ollama)
export const SUPER_MODELS = {
  // Ultra-powerful reasoning models (Ollama)
  DEEPSEEK_V4_PRO: {
    id: 'deepseek-v4-pro:cloud',
    name: 'DeepSeek V4 Pro (Cloud)',
    provider: 'ollama',
    contextWindow: 128000,
    capabilities: ['reasoning', 'coding', 'math', 'analysis', 'ultra-powerful'],
    type: 'text-generation',
    recommended: 'Best overall reasoning and coding'
  },
  QWEN_3_5_397B: {
    id: 'qwen3.5:397b-cloud',
    name: 'Qwen 3.5 397B (Cloud)',
    provider: 'ollama',
    contextWindow: 128000,
    capabilities: ['reasoning', 'coding', 'multilingual', 'ultra-powerful'],
    type: 'text-generation',
    recommended: 'Massive 397B model, extremely capable'
  },
  MISTRAL_LARGE_3_675B: {
    id: 'mistral-large-3:675b-cloud',
    name: 'Mistral Large 3 675B (Cloud)',
    provider: 'ollama',
    contextWindow: 128000,
    capabilities: ['reasoning', 'analysis', 'multilingual', 'ultra-powerful'],
    type: 'text-generation',
    recommended: 'Largest Mistral model, 675B parameters'
  },
  QWEN_3_VL_235B: {
    id: 'qwen3-vl:235b-cloud',
    name: 'Qwen 3 VL 235B (Cloud)',
    provider: 'ollama',
    contextWindow: 128000,
    capabilities: ['vision', 'multimodal', 'reasoning', 'ultra-powerful'],
    type: 'vision',
    recommended: 'Best vision model, 235B parameters'
  },
  KIMI_K2_7_CODE: {
    id: 'kimi-k2.7-code:cloud',
    name: 'Kimi K2.7 Code (Cloud)',
    provider: 'ollama',
    contextWindow: 128000,
    capabilities: ['coding', 'debugging', 'ultra-powerful'],
    type: 'text-generation',
    recommended: 'Top coding model'
  }
};

// Agentic Models (best for multi-step reasoning and tool use)
export const AGENTIC_MODELS = {
  DEEPSEEK_V4_FLASH: {
    id: 'deepseek-v4-flash:cloud',
    name: 'DeepSeek V4 Flash',
    provider: 'ollama',
    capabilities: ['fast-reasoning', 'tool-use', 'agentic'],
    recommended: 'Fast agentic reasoning'
  },
  KIMI_K2_THINKING: {
    id: 'kimi-k2-thinking:cloud',
    name: 'Kimi K2 Thinking',
    provider: 'ollama',
    capabilities: ['reasoning', 'planning', 'agentic'],
    recommended: 'Best for multi-step planning'
  },
  QWEN_3_CODER_480B: {
    id: 'qwen3-coder:480b-cloud',
    name: 'Qwen 3 Coder 480B',
    provider: 'ollama',
    capabilities: ['coding', 'tool-use', 'agentic', 'ultra-powerful'],
    recommended: 'Massive coding model with tool use'
  }
};

// Video/Audio/Conversion Models
export const MULTIMODAL_MODELS = {
  // Audio/Video (if available via Cloudflare)
  WHISPER_LARGE: {
    id: '@cf/openai/whisper',
    name: 'Whisper (Audio to Text)',
    type: 'speech-to-text',
    capabilities: ['audio', 'transcription', 'conversion']
  },
  
  // Image Models (already in IMAGE_GEN)
  // Video models would go here when Cloudflare adds them
  
  // Recommend Ollama models for video understanding
  X_Z_IMAGE_TURBO: {
    id: 'x/z-image-turbo:latest',
    name: 'X/Z Image Turbo',
    provider: 'ollama',
    type: 'vision',
    capabilities: ['vision', 'fast', 'image-understanding']
  }
};

// Get super powerful models
export function getSuperModels() {
  return Object.values(SUPER_MODELS);
}

// Get agentic models
export function getAgenticModels() {
  return Object.values(AGENTIC_MODELS);
}

// Get all multimodal models
export function getMultimodalModels() {
  return [
    ...Object.values(CLOUDFLARE_MODELS.VISION),
    ...Object.values(CLOUDFLARE_MODELS.SPEECH),
    ...Object.values(CLOUDFLARE_MODELS.IMAGE_GEN),
    ...Object.values(MULTIMODAL_MODELS)
  ];
}

// Get recommended models by use case
export function getRecommendedModels() {
  return {
    // Most powerful overall
    mostPowerful: SUPER_MODELS.QWEN_3_5_397B,
    
    // Best for coding
    bestCoding: SUPER_MODELS.KIMI_K2_7_CODE,
    
    // Best for reasoning
    bestReasoning: SUPER_MODELS.DEEPSEEK_V4_PRO,
    
    // Best for vision
    bestVision: SUPER_MODELS.QWEN_3_VL_235B,
    
    // Best for agents
    bestAgentic: AGENTIC_MODELS.KIMI_K2_THINKING,
    
    // Fastest powerful
    fastestPowerful: AGENTIC_MODELS.DEEPSEEK_V4_FLASH,
    
    // Best multimodal
    bestMultimodal: SUPER_MODELS.QWEN_3_VL_235B,
    
    // Best for analysis
    bestAnalysis: SUPER_MODELS.MISTRAL_LARGE_3_675B
  };
}

// Get model count
export function getModelCount() {
  return {
    cloudflare: {
      textGeneration: Object.keys(CLOUDFLARE_MODELS.TEXT_GENERATION).length,
      vision: Object.keys(CLOUDFLARE_MODELS.VISION).length,
      embeddings: Object.keys(CLOUDFLARE_MODELS.EMBEDDINGS).length,
      translation: Object.keys(CLOUDFLARE_MODELS.TRANSLATION).length,
      speech: Object.keys(CLOUDFLARE_MODELS.SPEECH).length,
      imageGen: Object.keys(CLOUDFLARE_MODELS.IMAGE_GEN).length,
      total: Object.values(CLOUDFLARE_MODELS).reduce((sum, cat) => sum + Object.keys(cat).length, 0)
    },
    super: Object.keys(SUPER_MODELS).length,
    agentic: Object.keys(AGENTIC_MODELS).length,
    multimodal: Object.keys(MULTIMODAL_MODELS).length,
    grandTotal: Object.values(CLOUDFLARE_MODELS).reduce((sum, cat) => sum + Object.keys(cat).length, 0) + 
                 Object.keys(SUPER_MODELS).length + 
                 Object.keys(AGENTIC_MODELS).length
  };
}
